export default function createMalariaOverlayWorker() {
  if (typeof Worker === 'undefined') {
    return null;
  }
  return new Worker(new URL('./malaria-overlay.worker.js', import.meta.url));
}
